<template>
  <div id="recruitCondition">
    <div class="recruit__container">
      <div class="recruit__wrapper">
        <p class="recruit__title">홈핏 전문가에 도전해보세요</p>
        <div class="recruit__tab">
          <p class="tab__workout" :class="{on: tab === 'workout'}" @click="changeTab('workout')"></p>
          <p class="tab__meditation" :class="{on: tab === 'meditation'}" @click="changeTab('meditation')"></p>
          <p class="tab__care" :class="{on: tab === 'care'}" @click="changeTab('care')"></p>
        </div>
        <div class="workout__condition" v-if="tab === 'workout'">
          <div class="condition__swiper">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <img src="https://dcse8twossp9.cloudfront.net/static/img/icon/yoga-gray.svg" alt="yoga">
                <span>요가</span>
              </div>
              <div class="swiper-slide">
                <img src="https://dcse8twossp9.cloudfront.net/static/img/icon/pila-gray.svg" alt="pila">
                <span>필라테스</span>
              </div>
              <div class="swiper-slide">
                <img src="https://dcse8twossp9.cloudfront.net/static/img/icon/wei-gray.svg" alt="weight">
                <span>웨이트</span>
              </div>
              <div class="swiper-slide">
                <img src="https://dcse8twossp9.cloudfront.net/static/img/icon/mom-gray.svg" alt="mom">
                <span>산전/산후</span>
              </div>
            </div>
            <div class="swiper-pagination"></div>
          </div>
          <p class="condition__tag">
            <span @click="clickConditionTag('yoga')">요가</span>
            <span @click="clickConditionTag('pila')">필라테스</span>
            <span @click="clickConditionTag('wei')">웨이트</span>
            <span @click="clickConditionTag('mom')">산전산후</span>
          </p>
          <div class="condition__column pc">
            <p class="condition__item">
              <img src="https://dcse8twossp9.cloudfront.net/static/img/icon/yoga-gray.svg" alt="yoga">
              <span>요가</span>
            </p>
            <p class="condition__item">
              <img src="https://dcse8twossp9.cloudfront.net/static/img/icon/pila-gray.svg" alt="pila">
              <span>필라테스</span>
            </p>
            <p class="condition__item">
              <img src="https://dcse8twossp9.cloudfront.net/static/img/icon/wei-gray.svg" alt="weight">
              <span>웨이트</span>
            </p>
            <p class="condition__item">
              <img src="https://dcse8twossp9.cloudfront.net/static/img/icon/mom-gray.svg" alt="mom">
              <span>산전/산후</span>
            </p>
          </div>
          <div class="condition__column nobg">
            <div class="condition__row">
              <p class="condition__item">
                <img src="https://dcse8twossp9.cloudfront.net/static/img/icon/doc-gray.svg">
                <span>3개 이상의 자격(수료)증</span>
              </p>
            </div>
            <div class="condition__row">
              <p class="condition__item">
                <img src="https://dcse8twossp9.cloudfront.net/static/img/icon/carrot-gray.svg">
                <span>3년 이상의 실제 지도 경험</span>
              </p>
            </div>
          </div>
        </div>
        <div class="meditation__condition" v-show="tab === 'meditation'">
          <div class="condition__common condition__left">
            <img class="lazy" data-src="https://dcse8twossp9.cloudfront.net/static/img/icon/yogamedi-gray.svg">
            <span>요가명상</span>
          </div>
          <div>
            <div class="condition__common condition__right">
              <img class="lazy" data-src="https://dcse8twossp9.cloudfront.net/static/img/icon/doc-gray.svg">
              <span>3개 이상의 요가 자격(이수)증 및<br>1개 이상의 명상 자격(이수)증</span>
            </div>
            <div class="condition__common condition__right">
              <img class="lazy" data-src="https://dcse8twossp9.cloudfront.net/static/img/icon/carrot-gray.svg">
              <span>3년 이상의 요가 수업 및<br>명상 실제 수업지도 경험</span>
            </div>
          </div>
        </div>
        <div class="care__condition" v-show="tab === 'care'">
          <div class="condition__column">
            <div class="condition__row condition__row_flex" style='display: flex;'>
              <p class="condition__item">
                <img src="https://dcse8twossp9.cloudfront.net/static/img/icon/pain-gray.svg" alt="pain">
                <span>전문 통증케어</span>
              </p>
              <p class="condition__item">
                <img src="https://dcse8twossp9.cloudfront.net/static/img/care/240822/care-80-px-bg.svg" alt="care">
                <span>근골격계 케어</span>
              </p>
            </div>
          </div>
          <div class="condition__column nobg">
            <div class="condition__row">
              <p class="condition__item">
                <img src="https://dcse8twossp9.cloudfront.net/static/img/icon/doc-gray.svg" alt="pain">
                <span>3개 이상의 자격(수료)증</span>
              </p>
            </div>
            <div class="condition__row">
              <p class="condition__item">
                <img src="https://dcse8twossp9.cloudfront.net/static/img/icon/carrot-gray.svg" alt="pain">
                <span>3년 이상의 실제 지도 경험</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.min.css';
export default {
  name: 'RecruitCondition',
  data(){
    return{
      tab: 'workout',
      swiper: null,
    }
  },
  mounted(){
    this.initializeSwiper()
  },
  methods: {
    initializeSwiper() {
      this.swiper = new Swiper(".condition__swiper", {
        slidesPerView: "auto",
        direction: 'vertical',
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });
    },
    changeTab(x){
      this.tab = x
      setTimeout(()=> { this.initializeSwiper()},300)
    },
    clickConditionTag(x){
      switch(x){
        case 'yoga': this.swiper.slideTo(0, 500); break;
        case 'pila': this.swiper.slideTo(1, 500); break;
        case 'wei': this.swiper.slideTo(2, 500); break;
        case 'mom': this.swiper.slideTo(3, 500); break;
        default: return;
      }
    },
    clickConditionTagForCare(x){
      switch(x){
        case 'pain': this.swiper.slideTo(0, 500); break;
        case 'care': this.swiper.slideTo(2, 500); break;
        default: return;
      }
    }
  }
}
</script>
<style scoped  lang="scss">
#recruitCondition {
  .care__condition {
    .condition__row_flex {
      display: flex;
      .condition__item:nth-child(2) {
        margin-left: 200px;
      }
    }
  }
}
@media all and (max-width: 768px) {
  #recruitCondition {
    .care__condition {
      .condition__row_flex {
        .condition__item:nth-child(2) {
          margin-left: 100px;
        }
      }
    }
  }
}
</style>
